import { render, staticRenderFns } from "./viewMessage.vue?vue&type=template&id=4799fc74&scoped=true&"
import script from "./viewMessage.vue?vue&type=script&lang=js&"
export * from "./viewMessage.vue?vue&type=script&lang=js&"
import style0 from "./viewMessage.vue?vue&type=style&index=0&id=4799fc74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4799fc74",
  null
  
)

export default component.exports